import React from 'react';
import W8BENForm from './components/W8BENForm'
const W8BEN = () => {
  return (<>
    <W8BENForm/>
  </>);
}

export default W8BEN;
